import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[fbDisableAutocomplete]',
})
export class DisableAutocompleteDirective implements OnInit {
  @Input() set disableAutocomplete(autocomplete: string) {
    if (autocomplete) {
      this.renderer2.setAttribute(this.elementRef.nativeElement, 'autocomplete', autocomplete);
    }
  }

  constructor(private elementRef: ElementRef, private renderer2: Renderer2) {}

  ngOnInit(): void {
    const randomString: string = Math.random().toString(36).slice(-6);
    const element: HTMLInputElement = this.elementRef.nativeElement;
    if (!this.isOnLoginPage()) {
      if (!element.name) {
        // NOTE: if set name without setTimeout it will be set, but after will be erased
        setTimeout(() => {
          this.renderer2.setAttribute(element, 'name', randomString);
        }, 0);
      }

      this.renderer2.setAttribute(element, 'autocomplete', 'new-password');
      this.renderer2.setAttribute(element, 'onfocus', `this.setAttribute('autocomplete', 'new-password');`);
      this.renderer2.setAttribute(element, 'autocorrect', 'off');
      this.renderer2.setAttribute(element, 'autocapitalize', 'none');
      this.renderer2.setAttribute(element, 'spellcheck', 'false');
    }
  }
  private isOnLoginPage(): boolean {
    return document.location.pathname.includes('/login');
  }
}
